import { useState } from "react";
import { Button } from "@mui/material";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { useAppSelector } from "../../../utils/hooks";
import { AppColor, AppConstants } from "../../../types/Constants";
import FilterDialog from "./filteringBeacon/FilterDialog";

export const BeaconFilterButton: React.FC = () => {

  const beaconState = useAppSelector(state => state.beacon);
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);

  const isFilterOn = () => {
    return (beaconState.filterCategory && beaconState.filterCategory !== AppConstants.AllCategoriesValue);
  };

  return (
    <>
      <Button
        sx={{ color: isFilterOn() ? AppColor.baseOrange : "black" }}
        color="inherit"
        onClick={() => setIsOpenFilter(true)}>
        <FilterAltOutlinedIcon />
        Categories
      </Button>
      <FilterDialog isOpen={isOpenFilter} onClose={() => setIsOpenFilter(false)} />
    </>
  );
};
